export function freelanceCommercialName() {
  try {
    return [localStorage.getItem("firstname"), localStorage.getItem("lastname")]
      .filter(Boolean)
      .join(" ")
      .trim();
  } catch {
    return "";
  }
}
